<template>
  <div class="h-100">
    <v-card elevation="0" class="bg-transparent h-100">
      <v-card-text class="pa-0 h-100">
        
        <v-data-table-server class="tickets-table bg-transparent" :headers="visitor ? headersVisitor : headers" :items="tickets"
          fixed-header hover :height="$vuetify.display.mdAndDown ? '500px' : 'calc(100vh - 180px)'"
          v-model:items-per-page="filters.itemsPerPage" :items-length="totalItems" :loading="loadingTickets"
          @update:options="loadTickets" item-value="idticket">

          <!-- Header Personalizado (Opcional, para estilo limpio) -->
          <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
            <tr class="ticket-header-row">
              <template v-for="column in columns" :key="column.key">
                <th class="text-caption font-weight-bold text-uppercase text-medium-emphasis border-b bg-grey-lighten-5 py-3"
                    :style="{ width: column.width, minWidth: column.width }">
                  {{ column.title }}
                </th>
              </template>
            </tr>
          </template>

          <!-- Fila de Item Personalizada -->
          <template v-slot:item="{ item }">
            <tr class="ticket-row transition-all border-b" :class="[disableClass(item.estado), {'bg-blue-lighten-5': itsCopyTicket(item)}]">
              
              <!-- Columna Share/Copy -->
              <td class="px-2">
                <v-tooltip text="Te agregaron en este ticket" v-if="itsCopyTicket(item)" location="top">
                  <template v-slot:activator="{ props }">
                    <div v-bind="props" class="d-flex justify-center">
                      <v-avatar color="teal-accent-4" size="24">
                        <i class="fa-solid fa-share-nodes text-white" style="font-size: 12px;"></i>
                      </v-avatar>
                    </div>
                  </template>
                </v-tooltip>
              </td>

              <!-- Solicitante -->
              <td class="py-3">
                <v-menu open-on-hover :close-on-content-click="false" location="end">
                  <template v-slot:activator="{ props }">
                    <div class="d-flex align-center cursor-pointer" v-bind="props">
                      <v-avatar size="36" class="mr-3 border bg-white">
                        <img v-if="item.solicitante.avatar" :src="item.solicitante.avatar" alt="Avatar" style="object-fit: cover; width: 100%; height: 100%;">
                        <v-img v-else :src="require('@/assets/' + item.solicitante.tipouser.toLowerCase() + '.png')" cover></v-img>
                      </v-avatar>
                      <div class="d-flex flex-column" style="max-width: 150px;">
                        <span class="text-body-2 font-weight-bold text-grey-darken-3 text-truncate">
                          {{ capitalizeWords(oneName(item.solicitante.nombres) + ' ' + oneName(item.solicitante.apellidos)) }}
                        </span>
                        <span class="text-caption text-medium-emphasis text-truncate">
                          {{ item.solicitante.tipouser === 'colaborador' ? item.solicitante.cargo : item.solicitante.carrera }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <!-- Popover Detalle Usuario -->
                  <v-card width="320" class="rounded-xl shadow-lg">
                    <div class="bg-grey-lighten-5 pa-4 d-flex align-center border-b">
                      <v-avatar size="56" class="mr-4 border bg-white">
                        <img v-if="item.solicitante.avatar" :src="item.solicitante.avatar" alt="Avatar" style="object-fit: cover; width: 100%; height: 100%;">
                        <v-img v-else :src="require('@/assets/' + item.solicitante.tipouser.toLowerCase() + '.png')" cover></v-img>
                      </v-avatar>
                      <div>
                        <div class="font-weight-bold text-subtitle-2">{{ capitalizeWords(item.solicitante.nombres + ' ' + item.solicitante.apellidos) }}</div>
                        <div class="text-caption text-medium-emphasis">{{ item.solicitante.tipouser }}</div>
                      </div>
                    </div>
                    <v-list density="compact" class="py-2">
                      <v-list-item>
                        <template v-slot:prepend><i class="fa-solid fa-envelope mr-3 text-medium-emphasis" style="font-size: 14px;"></i></template>
                        <v-list-item-title class="text-caption">{{ item.correo }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <template v-slot:prepend><i class="fa-solid fa-phone mr-3 text-medium-emphasis" style="font-size: 14px;"></i></template>
                        <v-list-item-title class="text-caption">{{ item.celular }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="item.whatsapp">
                        <template v-slot:prepend><i class="fa-brands fa-whatsapp mr-3 text-success" style="font-size: 16px;"></i></template>
                        <v-list-item-title class="text-caption">{{ item.whatsapp }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </td>

              <!-- Fecha -->
              <td>
                <div class="d-flex flex-column">
                  <span class="text-body-2 font-weight-medium text-grey-darken-2">{{ fechasmall("DD/MM/YY", item.created_at) }}</span>
                  <span class="text-caption text-medium-emphasis">{{ fechasmall("HH:mm", item.created_at) }}</span>
                </div>
              </td>

              <!-- Sede -->
              <td>
                <v-chip size="x-small" color="grey-darken-1" variant="outlined" label class="font-weight-bold">
                  {{ item.sede }}
                </v-chip>
              </td>

              <!-- Tipo -->
              <td>
                <TipoTicketComponent :key="item.tipo" :width="'100%'" :tipo="item.tipo" :idticket="item.idticket"
                  :disabled="isDisabled(item.estado)" :readonly="visitor"></TipoTicketComponent>
              </td>

              <!-- Asunto (Link Principal) -->
              <td class="py-3" style="max-width: 400px;">
                <div @click="openTicket(item)" class="cursor-pointer ticket-subject-cell">
                  <div class="text-body-2 font-weight-bold text-primary text-wrap mb-1 ticket-subject">
                    {{ item.asunto }}
                  </div>
                  <!-- Chips de referencia inline si existen -->
                  <v-chip v-if="item.ticket_referencia" size="x-small" color="amber-darken-2" variant="flat" class="font-weight-bold text-white mr-2" 
                    @click.stop="openTicket(item, item.ticket_referencia)">
                    <i class="fa-solid fa-link mr-1" style="font-size: 10px;"></i> Ref
                  </v-chip>
                </div>
              </td>

              <!-- Agente -->
              <td>
                <AgenteTicketComponent :width="'100%'" :key="item.agente" :idticket="item.idticket" :agente="item.agente"
                  :disabled="isDisabled(item.estado)" :readonly="visitor"></AgenteTicketComponent>
              </td>

              <!-- Ticket Referencia (Columna dedicada oculta o minimalista) -->
              <td>
                <div v-if="item.ticket_referencia" class="text-caption text-medium-emphasis">
                  #{{ item.ticket_referencia }}
                </div>
                <div v-else class="text-caption text-disabled">-</div>
              </td>

              <!-- Categoría -->
              <td>
                <v-chip size="small" color="indigo-lighten-5" class="text-indigo-darken-2 font-weight-bold" label>
                  {{ item.categoria.nombre }}
                  <v-tooltip activator="parent" location="top">{{ item.categoria.descripcion }}</v-tooltip>
                </v-chip>
              </td>

              <!-- Subcategoría -->
              <td>
                <v-chip v-if="item.subcategoria" size="small" color="grey-lighten-4" class="text-grey-darken-3 font-weight-medium" label>
                  {{ item.subcategoria.nombre }}
                  <v-tooltip activator="parent" location="top">{{ item.subcategoria.descripcion }}</v-tooltip>
                </v-chip>
                <span v-else class="text-caption text-disabled">-</span>
              </td>

              <!-- Prioridad -->
              <td>
                <PrioridadTicketComponent :width="'100%'" :key="item.prioridad" :prioridad="item.prioridad"
                  :idticket="item.idticket" :disabled="isDisabled(item.estado)" :readonly="visitor">
                </PrioridadTicketComponent>
              </td>

              <!-- Estado -->
              <td>
                <EstadoTicketComponent :disabled="item.cierre_confirmado == 1" :width="'100%'" :key="item.estado"
                  :estado="item.estado" :idticket="item.idticket" :readonly="visitor"></EstadoTicketComponent>
              </td>

              <!-- Confirmación -->
              <td v-if="!visitor">
                <v-chip v-if="item.cierre_confirmado" color="green-lighten-5" class="text-green-darken-3 font-weight-bold border-green-lighten-4" label variant="flat" size="small">
                  <i class="fa-solid fa-check-double mr-1" style="font-size: 12px;"></i> OK
                </v-chip>
              </td>

            </tr>
          </template>

        </v-data-table-server>
      </v-card-text>
    </v-card>

    <!-- Overlay Confirmación -->
    <v-overlay v-model="overlayConfirmTicket" class="align-center justify-center bg-overlay-blur">
      <v-card width="500" class="rounded-xl shadow-lg">
        <v-card-text class="text-center pa-8">
          <v-img :src="require('@/assets/graciasCTM.webp')" width="180" class="mx-auto mb-6" />
          <h3 class="text-h5 font-weight-black text-grey-darken-3 mb-2">¡Ticket Registrado!</h3>
          <p class="text-body-1 text-medium-emphasis mb-6">
            Hemos enviado un correo de confirmación con los detalles de tu solicitud.
          </p>
          <v-btn @click="closeOverlayConfirmTicket()" color="primary" rounded="lg" size="large" elevation="2" block
            style="background: linear-gradient(135deg, #002B49 0%, #005691 100%);">
            Entendido
          </v-btn>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
 
<script>
import { shallowRef } from 'vue';
import FiltrosTicketsComponent from "../components/FiltrosTicketsComponent.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import Filters from '@/modules/Shared/Filters';

import EstadoTicketComponent from "../components/EstadoTIcketComponent.vue";
import AgenteTicketComponent from './AgenteTicketComponent.vue';
import PrioridadTicketComponent from "./PrioridadTicketComponent.vue";
import TipoTicketComponent from "./TipoTicketComponent.vue";
import scroller from "@/components/scroller.vue"
import { socket } from '@/ws-client';

export default {
  mixins: [Filters],
  components: {
    EstadoTicketComponent,
    AgenteTicketComponent,
    PrioridadTicketComponent,
    TipoTicketComponent,
    scroller,
    FiltrosTicketsComponent,
  },
  props: {
    tickets: {
      type: Object
    },

    visitor: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      headers: [
        { title: "", key: "share", width: "40px", sortable: false },
        { title: "Solicitante", key: "solicitante", width: "220px", sortable: false },
        { title: "Fecha", key: "fecha", width: "120px", sortable: false },
        { title: "Sede", key: "sede", width: "80px", sortable: false },
        { title: "Tipo", key: "tipo", width: "240px", sortable: false },
        { title: "Asunto", key: "asunto", sortable: false, width: "350px" },
        { title: "Agente", key: "agente", width: "200px", sortable: false },
        { title: "Ref", key: "ticket_referencia", sortable: false, width: "80px" },
        { title: "Categoría", key: "categoria", width: "200px", sortable: false },
        { title: "Subcat", key: "subcategoria", width: "200px", sortable: false },
        { title: "Prioridad", key: "prioridad", width: "160px", sortable: false },
        { title: "Estado", key: "estado", width: "180px", sortable: false },
        { title: "Conf", key: "cierre_confirmado", width: "120px", sortable: false },
      ],
      headersVisitor: [
        { title: "", key: "share", width: "40px", sortable: false },
        { title: "Yo", key: "solicitante", width: "220px", sortable: false },
        { title: "Fecha", key: "fecha", width: "120px", sortable: false },
        { title: "Sede", key: "sede", width: "80px", sortable: false },
        { title: "Tipo", key: "tipo", width: "160px", sortable: false },
        { title: "Asunto", key: "asunto", width: "350px", sortable: false },
        { title: "Agente", key: "agente", width: "200px", sortable: false },
        { title: "Ref", key: "ticket_referencia", sortable: false, width: "80px" },
        { title: "Categoría", key: "categoria", width: "200px", sortable: false },
        { title: "Subcat", key: "subcategoria", width: "200px", sortable: false },
        { title: "Prioridad", key: "prioridad", width: "160px", sortable: false },
        { title: "Estado", key: "estado", width: "180px", sortable: false },
      ]
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapState("tickets", ["loadingTickets", "totalItems", "filters"]),
    ...mapState("tickets/registroticket", ['overlayConfirmTicket'])
  },
  methods: {
    ...mapActions("tickets", ['getTicketsAxios']),
    ...mapMutations('tickets', ['setTicket']),
    ...mapMutations('tickets/registroticket', ['setTicket', 'closeOverlayConfirmTicket']),

    itsCopyTicket(item){

       return item.copy_ticket_users.some(elm => elm.email === this.user.email)
    },  

    openTicket(ticket, ticketReferencia = null) {
      //this.openTicket(ticket);
      const codigoticket = ticketReferencia ? ticketReferencia : ticket.codigo_ticket
      if (!this.isRoleVisitor()) {
        this.$router.push({ name: 'ticketView', params: { codigoticket: codigoticket } })
      } else {
        this.$router.push({ name: 'visualizeTicket', params: { codigoticket: codigoticket } })
      }
    },

    loadTickets({ page, itemsPerPage, sortBy }) {
      let iduser = this.isRoleVisitor() ? this.user.iduser : null
      this.getTicketsAxios({ loading: true, iduser, page: page })
    }
  },


  mounted() {
    let iduser = this.isRoleVisitor() ? this.user.iduser : null

    this.getTicketsAxios({ loading: true, iduser, page: 1, isAgente: this.isAgente() });

    socket.on('LOAD_TICKET', data => {
      this.getTicketsAxios({ loading: false, iduser, page: 1 });
    })
  }

};
</script>

<style lang="scss" scoped>
.tickets-table {
  background: transparent !important;
  
  :deep(th) {
    font-size: 11px !important;
    letter-spacing: 0.5px;
  }
  
  :deep(td) {
    font-size: 13px !important;
    border-bottom: 1px solid #f5f5f5 !important;
  }
}

.ticket-row:hover {
  background-color: #FAFAFA !important;
  
  .ticket-subject {
    color: #1565C0 !important; /* Azul más vivo al hover */
    text-decoration: underline;
  }
}

.ticket-subject-cell:hover {
  cursor: pointer;
}

.shadow-lg {
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
}

.bg-overlay-blur {
  backdrop-filter: blur(4px);
}

.close-ticket {
  opacity: 0.60;
  filter: grayscale(100%);
}

.cancel-ticket {
  text-decoration: line-through;
  filter: grayscale(100%);
}

.no-cancel {
  opacity: 1 !important;
  filter: grayscale(0) !important;
  -webkit-filter: grayscale(0) !important;
}
</style>